import api from './api'

const rulesService = {
  getList:     (params = {})          => api.get('/api/v1/rules', { params }).then(r => r.data),
  getById:     (id)                   => api.get(`/api/v1/rules/${id}`).then(r => r.data),
  create:      (payload)              => api.post('/api/v1/rules', payload).then(r => r.data),
  update:      (id, payload)          => api.put(`/api/v1/rules/${id}`, payload).then(r => r.data),  // PUT not PATCH
  duplicate:   (id)                   => api.post(`/api/v1/rules/${id}/duplicate`).then(r => r.data),
  toggleStatus:(id, status)           => api.patch(`/api/v1/rules/${id}/status`, { status }).then(r => r.data),
  archive:     (id)                   => api.delete(`/api/v1/rules/${id}`).then(r => r.data),
  getVersions: (id)                   => api.get(`/api/v1/rules/${id}/versions`).then(r => r.data),
  rollback:    (id, version, reason)  => api.post(`/api/v1/rules/${id}/rollback`, { version, reason }).then(r => r.data),
  // Sandbox
  evaluate:    (payload)              => api.post('/api/v1/sandbox/evaluate', payload).then(r => r.data),
  // compare maps to evaluate with mode=all for side-by-side testing
  compare:     (payload)              => api.post('/api/v1/sandbox/evaluate', { ...payload, mode: 'all' }).then(r => r.data),
  // saveDraft maps to create with status=INACTIVE
  saveDraft:   (payload)              => api.post('/api/v1/rules', { ...payload, status: 'INACTIVE' }).then(r => r.data),
  saveTestCase:(payload)              => api.post('/api/v1/sandbox/evaluate', payload).then(r => r.data),
}

export default rulesService
